import { createSlice, isAnyOf } from "@reduxjs/toolkit"
import { AllowedEntityNames } from "../constants"
import {
    setLicenseModalContext,
    setLicensePaywallType,
    setLicenseUpgrade,
    setAddOnPaywallType,
} from "./actions"
import { assignPurchasedLicense, listLicensesForUser, updateLicense } from "./thunks"
import { LicenseModalContext, LicensePaywallType } from "./types"
import { AddOns } from "@nova/constants"
import { AddOn, License } from "@nova/schemas"

const initialState: {
    licensesById: Record<string, License>
    addOnsById: Record<string, AddOn>
    subscriptionModalContext: LicenseModalContext
    addOnPaywallType?: AddOns
    licensePaywallType: LicensePaywallType
    upgradeLicense?: License
} = {
    licensesById: {},
    addOnsById: {},
    subscriptionModalContext: {
        subscriptionModalId: undefined,
        isMultiAssign: false,
        isAddOn: false,
        isTransferring: false,
    },
    addOnPaywallType: undefined,
    licensePaywallType: "usage",
    upgradeLicense: undefined,
}

export const slice = createSlice({
    name: AllowedEntityNames.Licenses,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(setLicenseModalContext, (state, action) => {
                state.subscriptionModalContext = action.payload
            })
            .addCase(setAddOnPaywallType, (state, action) => {
                state.addOnPaywallType = action.payload
            })
            .addCase(setLicensePaywallType, (state, action) => {
                state.licensePaywallType = action.payload
            })
            .addCase(setLicenseUpgrade, (state, action) => {
                state.upgradeLicense = action.payload
            })
            .addCase(listLicensesForUser.fulfilled, (state, action) => {
                if (!action.payload) return
                const { licenses, addOns } = action.payload
                licenses.forEach((item) => {
                    const { licenseId } = item

                    state.licensesById[licenseId] = {
                        ...item,
                    }
                })
                addOns.forEach((item) => {
                    const { licenseId } = item

                    state.addOnsById[licenseId] = {
                        ...item,
                    }
                })
            })
            .addMatcher(
                isAnyOf(assignPurchasedLicense.fulfilled, updateLicense.fulfilled),
                (state, action) => {
                    if (!action.payload) return
                    const { updatedLicense, revokedLicense } = action.payload

                    const updates = [updatedLicense, revokedLicense]
                    updates.forEach((license) => {
                        if (!license) return
                        const assigneeId =
                            license.assigneeId === "unassigned" ? undefined : license.assigneeId

                        if (license.isAddOn)
                            state.addOnsById[license.licenseId] = {
                                ...license,
                                assigneeId,
                            }
                        else
                            state.licensesById[license.licenseId] = {
                                ...license,
                                assigneeId,
                            }
                    })
                }
            )
    },
})

const { reducer } = slice

export { reducer as licensesSliceReducer }
